<app-content-container class="w-fill-available" data-testid="admin-user-group">
  <app-banner-card
    [header]="'pages.admin.userGroup.navigationTitle' | translate"
    [headerHeight]="44"
    [breadcrumbs]="breadcrumbs"
  />

  <mat-tab-group class="w-full profile-tab-group">
    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="admin-user-group-tab-groups">{{
          'pages.admin.userGroup.tabs.userGroups.title' | translate
        }}</span>
      </ng-template>

      <div class="min-h-[calc(100vh-400px)] pt-7">
        <app-admin-user-groups-tab data-testid="admin-user-group-tab-panel-groups" />
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="admin-user-group-tab-users">{{ 'pages.admin.userGroup.tabs.users.title' | translate }}</span>
      </ng-template>

      <div class="min-h-[calc(100vh-400px)] pt-7">
        <app-admin-users-tab data-testid="admin-user-group-tab-panel-users" [userGroups]="store.userGroups$()" />
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <span data-testid="admin-user-group-tab-invitations">{{
          'pages.admin.userGroup.tabs.invitations.title' | translate
        }}</span>
      </ng-template>

      <div class="min-h-[calc(100vh-400px)] pt-7">
        <app-admin-invitations-tab
          data-testid="admin-user-group-tab-panel-invitations"
          [userGroups]="store.userGroups$()"
          (refreshUserGroups)="store.fetchUserGroups()"
        />
      </div>
    </mat-tab>
  </mat-tab-group>
</app-content-container>
